import React from 'react';
import {useTranslation} from 'react-i18next';
import DetailsSidebarKeyValue from '../DetailsSidebarKeyValue';

interface KeyValuePair {
  label: string;
  value?: string | null;
  valueClassName?: string;
  showWhenEmpty?: boolean;
  emptyText?: string;
  onClick?: () => void;
  isClickable?: boolean;
  to?: string | { pathname: string; search?: string };
}

interface DetailsInfoCardProps {
  title: string;
  keyValuePairs: KeyValuePair[];
  onEditClick?: () => void;
}

const DetailsInfoCard: React.FC<DetailsInfoCardProps> = ({
  title,
  keyValuePairs,
  onEditClick
}) => {
  const {t} = useTranslation();
  return (
    <div id="quick-info-card" className="bg-white shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-stone-900">
          {title}
        </h1>
        {onEditClick && (
          <button
            onClick={onEditClick}
            className="text-gray-600 hover:text-gray-900 transition-colors"
            title={t('common.actions.edit')}
          >
            <i className="fa fa-edit text-xl"></i>
          </button>
        )}
      </div>

      <div className="space-y-3">
        {keyValuePairs.map((pair, index) => (
          <DetailsSidebarKeyValue
            key={index}
            label={pair.label}
            value={pair.value}
            valueClassName={pair.valueClassName}
            showWhenEmpty={pair.showWhenEmpty}
            emptyText={pair.emptyText}
            onClick={pair.onClick}
            isClickable={pair.isClickable}
            to={pair.to}
          />
        ))}
      </div>
    </div>
  );
};

export default DetailsInfoCard;
